import { types } from 'mobx-state-tree';


const CONSTRUCTION_TYPES = {
    EXISTING: 'existing',
    NEW: 'new',
};

const ConstructionTypeEnum = types.enumeration('ConstructionType', Object.values(CONSTRUCTION_TYPES));

export {
    ConstructionTypeEnum,
};
export default CONSTRUCTION_TYPES;
